<template>
    <div class="product-detail" v-if="product.id">

        <PageHeader :title="product.translate[0].name" icon="fas fa-info-circle" />

        <div class="container py-3 py-sm-5">
            <div class="row mb-3">
                <div class="col-12 col-sm-5 text-center p-0 px-sm-3">
                    <!-- <img class="rounded w-100 mb-3 mb-sm-0" :src="product.product_images[0].image || '/assets/images/noimg.png'" /> -->

                    <Galleria
                        ref="galleria"
                        v-model:activeIndex="activeIndex"
                        :value="product.product_images"
                        :numVisible="5"
                        containerStyle="max-width: 640px;"
                        :showThumbnails="product.product_images.length > 1 ? showThumbnails : false"
                        :showItemNavigators="product.product_images.length > 1 ? true : false"
                        :showItemNavigatorsOnHover="product.product_images.length > 1 ? true : false"
                        :circular="true"
                        :autoPlay="isAutoPlay"
                        :transitionInterval="3000"
                        :responsiveOptions="responsiveOptionsG"
                        thumbnailsPosition="bottom"
                        containerClass="h-100"
                        :pt="{
                            content: {
                                class: ['bg-dark p-0 position-relative', { 'd-flex flex-1 justify-content-center': fullScreen }, 'h-100'],
                                style: ['width: auto;', G.is_mobile() ? 'min-height: 450px; height: 450px !important;' : (!fullScreen ? 'min-height: 750px; height: 750px !important;' : 'min-height: 1050px; height: 1050px !important;')],
                            },
                            itemsContainer: 'h-100 p-2',
                            thumbnail: {
                                class: 'border border-secondary rounded',
                            },
                            thumbnailContent: 'bg-dark',
                        }"
                    >
                        <template #item="slotProps">
                            <!-- <img :src="slotProps.item.image" :style="[{ width: !fullScreen ? '100%' : '', display: !fullScreen ? 'block' : '', height: !fullScreen ? '750px' : '' }]" /> -->
                            <div :style="[{ background: `url(${slotProps.item.image}) center no-repeat`, 'background-size': 'contain', width: !fullScreen ? '100%' : '', height: !fullScreen ? '100%' : '', display: !fullScreen ? 'block' : '' }]"></div>
                        </template>
                        <template #thumbnail="slotProps">
                            <div class="grid grid-nogutter justify-content-center">
                                <!-- <img :src="slotProps.item.image" style="display: block; width: 50px;" /> -->
                                <div :style="[{ background: `url(${slotProps.item.image}) center no-repeat`, 'background-size': 'contain', width: !fullScreen ? '60px' : '', height: !fullScreen ? '60px' : '', display: !fullScreen ? 'block' : '' }]"></div>
                            </div>
                        </template>
                        <!-- <template #footer>
                            <div class="d-flex align-items-center bg-black text-white">
                                <Button icon="fas fa-list" @click="onThumbnailButtonClick" :pt="{ root: { class: 'border-0 text-white', style: 'background: transparent' } }" />
                                <Button :icon="slideButtonIcon" @click="toggleAutoSlide" :pt="{ root: { class: 'border-0 text-white', style: 'background: transparent' } }" />
                                <span v-if="product.product_images" class="title-container">
                                    <span class="text-sm p-3">{{ activeIndex + 1 }}/{{ product.product_images.length }}</span>

                                    <span class="fw-bold text-sm p-3">{{ product.product_images[activeIndex].type }}</span>
                                    <span class="text-sm p-3">{{ product.product_images[activeIndex].rank }}</span>
                                    <span class="text-sm p-3">{{ product.product_images[activeIndex].title }}</span>

                                </span>
                                <Button :icon="fullScreenIcon" @click="toggleFullScreen" :pt="{ root: { class: 'border-0 ms-auto text-white', style: 'background: transparent;' } }" />
                            </div>
                        </template> -->
                    </Galleria>

                </div>
                <div class="col-12 col-sm-7 product-detail-info bg-site1 pt-0">
                    <div v-if="product.price" class="mb-4">
                        <h4 class="title-price pt-31"><small>{{ TR.price }}</small></h4>
                        <h1 class="fw-bold">{{ $filters.formatCurrency(product.price) }}</h1>
                    </div>

                    <table class="table table-flex1 table-bordered table-striped w-sm-75">
                        <tbody>
                            <tr>
                                <td class="fw-bold">{{ TR.production }} {{ TR.year }}</td>
                                <td>{{ product.years }}</td>
                            </tr>
                            <tr>
                                <td class="fw-bold">{{ TR.quarter }}</td>
                                <td>{{ product.quarters }}</td>
                            </tr>
                            <tr v-for="(item, index) in product_details" :key="index">
                                <td class="fw-bold">{{ item.name }}</td>
                                <td>{{ item.data }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

            <div class="row py-3 py-sm-5 mb-3">
                <div class="col-sm-12">
                    <ul class="nav nav-tabs nav-underline cursor-pointer" role="tablist">
                        <li class="nav-item" role="presentation"><a data-bs-toggle="tab" role="tab" data-bs-target="#description" class="nav-item active">{{ TR.description }}</a></li>
                        <!-- <li class="nav-item" role="presentation"><a data-bs-toggle="tab" role="tab" data-bs-target="#drink_rule" class="nav-item">{{ TR.drink_rule }}</a></li> -->
                    </ul>
                    <div class="tab-content p-2">
                        <div class="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="home-tab" tabindex="0" v-html="product.translate[0].description"></div>
                        <!-- <div class="tab-pane fade" id="drink_rule" role="tabpanel" aria-labelledby="profile-tab" tabindex="0" v-html="product.translate[0].drink_rule"></div> -->
                    </div>
                </div>
            </div>

            <!-- Similar Products -->
            <template v-if="products.length">

                <div class="w-100 d-flex justify-content-center">
                    <div class="w-50 border-2 border-bottom"></div>
                </div>

                <div class="text-center fs-4 fw-bold mb-4 mt-5">{{ TR.similar_products }}</div>

                <Carousel
                    :value="products"
                    :numVisible="products.length >= 2 && products.length >= 4 ? 4 : products.length"
                    :numScroll="1"
                    :responsiveOptions="responsiveOptions"
                    :circular="products.length > 1 ? true : false"
                    :autoplayInterval="products.length > 1 ? 5000 : 0"
                    :showIndicators="products.length > 1 ? true : false"
                    :showNavigators="products.length > 1 ? true : false"
                    :pt="{
                        contentContainer: {
                            class: [{ 'align-items-center': !G.is_mobile() && products.length < 3 }],
                        },
                    }"
                >

                    <!--
                        Button: {
                            class: [{ 'd-none': products.length < 3 }],
                        },
                        pcNextButton: {
                            class: [{ 'd-none': products.length < 3 }],
                        },
                    :contentClass="products.length < 3 ? '' : ''"
                    :containerClass="products.length < 3 ? 'd-flex justify-content-center align-items-center' : ''" -->
                    <template #item="slotProps">
                        <Product :data="slotProps.data" :lang="TR" />
                    </template>
                </Carousel>

            </template>

        </div>
    </div>
</template>


<script>
import { onBeforeMount, onMounted, onUnmounted, ref, watchEffect } from 'vue';
import { useStore } from '@/store';
import { useRoute } from 'vue-router';

import Galleria from 'primevue/galleria';
// import Button from 'primevue/button';
import Carousel from 'primevue/carousel';

import PageHeader from '@/components/header/PageHeader';
import Product from '@/components/card/Product';
// import { products } from '@/data/products';

import { G, ajax } from '@/_common';

export default {
    title: "Ətraflı",
    name: "ProductDetailP",
    components: {
		PageHeader,
        Product,
        Galleria,
        // Button,
        Carousel,
	},
	props: {
		data: {
			type: Object
		}
	},
	setup() {
        const store = useStore();
        const route = useRoute();

        const product = ref({});
        const filters = ref([]);
        const products = ref([]);
        const product_filters = ref([]);
        const product_details = ref([]);
        const TR = ref();

        const product_id = route.params && route.params.id ? parseInt(route.params.id) : 0;

        const plist = [];

        const galleria = ref();
        const activeIndex = ref(0);
        const isAutoPlay = ref(false);
        const responsiveOptions = ref([]);
        const showThumbnails = ref(true);
        const fullScreen = ref(false);

        const responsiveOptionsG = ref([
            {
                breakpoint: '1300px',
                numVisible: 4
            },
            {
                breakpoint: '575px',
                numVisible: 2
            }
        ]);

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        onBeforeMount(async () => {
            await ajax({
                url: store.getProductById(product_id),
                success: (e) => {
                    product.value = e.data;
                    product_filters.value = product.value.product_filters.map(f => f.filter_id);
                }
            });

            await ajax({
				url: store.getFilters(),
				success: (e) => {
					filters.value = e.data;
				}
			});

            // Build product details from it`s filters
            filters.value.forEach((g) => {
                let pdvalue = [];
                g.group_filters.forEach(f => {
                    if( product_filters.value.includes(f.id) ){
                        pdvalue.push(f.translate[0].name);
                    }
                });
                if( pdvalue.length > 0 ){
                    product_details.value.push({name: g.translate[0].name, data: pdvalue.join(', ')});
                }
            });

			await ajax({
				url: store.getProductsSimilarByCategory(product.value.id, product.value.category_id),
				success: (e) => {
					products.value = e.data;

                    responsiveOptions.value = [
                        {
                            breakpoint: '4000px',
                            numVisible: products.value.length > 5 ? 5 : products.value.length+1,
                            numScroll: 1,
                        },
                        {
                            breakpoint: '1920px',
                            numVisible: products.value.length > 4 ? 4 : products.value.length+1,
                            numScroll: 1,
                        },
                        {
                            breakpoint: '1380px',
                            numVisible: products.value.length > 3 ? 3 : products.value.length+1,
                            numScroll: 1,
                        },
                        {
                            breakpoint: '800px',
                            numVisible: 2,
                            numScroll: 1,
                        },
                        {
                            breakpoint: '576px',
                            numVisible: 1,
                            numScroll: 1,
                        }
                    ];
				}
			});
        });

        onMounted(() => {
            // bindDocumentListeners();
        });

        onUnmounted(() => {
            // unbindDocumentListeners();
        });





        // const onThumbnailButtonClick = () => {
        //     showThumbnails.value  = !showThumbnails.value ;
        // };
        // const toggleAutoSlide = () => {
        //     isAutoPlay.value  = !isAutoPlay.value ;
        // };
        // const toggleFullScreen = () => {
        //     if (fullScreen.value ) {
        //         closeFullScreen();filters.value
        //     } else {
        //         openFullScreen();
        //     }
        // };
        // const onFullScreenChange = () => {
        //     fullScreen.value  = !fullScreen.value ;
        // };
        // const openFullScreen = () =>{
        //     let elem = galleria.value.$el;

        //     if (elem.requestFullscreen) {
        //         elem.requestFullscreen();
        //     } else if (elem.mozRequestFullScreen) {
        //         /* Firefox */
        //         elem.mozRequestFullScreen();
        //     } else if (elem.webkitRequestFullscreen) {
        //         /* Chrome, Safari & Opera */
        //         elem.webkitRequestFullscreen();
        //     } else if (elem.msRequestFullscreen) {
        //         /* IE/Edge */
        //         elem.msRequestFullscreen();
        //     }
        // };
        // const closeFullScreen = () => {
        //     if (document.exitFullscreen) {
        //         document.exitFullscreen();
        //     } else if (document.mozCancelFullScreen) {
        //         document.mozCancelFullScreen();
        //     } else if (document.webkitExitFullscreen) {
        //         document.webkitExitFullscreen();
        //     } else if (document.msExitFullscreen) {
        //         document.msExitFullscreen();
        //     }
        // };
        // const bindDocumentListeners = () => {
        //     document.addEventListener('fullscreenchange', onFullScreenChange);
        //     document.addEventListener('mozfullscreenchange', onFullScreenChange);
        //     document.addEventListener('webkitfullscreenchange', onFullScreenChange);
        //     document.addEventListener('msfullscreenchange', onFullScreenChange);
        // };
        // const unbindDocumentListeners = () => {
        //     document.removeEventListener('fullscreenchange', onFullScreenChange);
        //     document.removeEventListener('mozfullscreenchange', onFullScreenChange);
        //     document.removeEventListener('webkitfullscreenchange', onFullScreenChange);
        //     document.removeEventListener('msfullscreenchange', onFullScreenChange);
        // };

        // const fullScreenIcon = computed(() => {
        //     return `fas ${fullScreen.value ? 'fa-window-minimize' : 'fa-window-maximize'}`;
        // });
        // const slideButtonIcon = computed(() => {
        //     return `fas ${isAutoPlay.value ? 'fa-pause' : 'fa-play'}`;
        // });


        return {
            G,
            TR,
            product,
            products,
            plist,
            product_details,

            galleria,
            activeIndex,
            showThumbnails,
            isAutoPlay,
            responsiveOptionsG,
            responsiveOptions,
            fullScreen,
            // onThumbnailButtonClick,
            // onFullScreenChange,
            // slideButtonIcon,
            // fullScreenIcon,
            // toggleFullScreen,
            // toggleAutoSlide,
        };
    },
}
</script>

<style lang="scss">
.product-detail{
    .nav-item{
        padding: 8px;
    }
    .nav-item.active{
        border-bottom: 2px solid rgba(var(--site-primary-color-rgb), .9);
    }
    // .table tr td{
    //     // background-color: transparent;
    // }
    .product-detail-info{
        padding: 20px;
    }
    .product-detail-info{
        border-radius: 5px;
        // color: #fff;
    }
    // .product-detail-info a{
    //     // border-bottom: 1px solid #fff;
    //     // color: #fff;
    // }
    .product-detail-info .table tr td{
        border-bottom: 1px solid #ffffff3a;
        // color: #fff;
    }
    .product-detail-info a:hover{
        color: #f3c0c0;
    }
    .p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {
        background-color: rgb(var(--site-primary-color-rgb)) !important;
    }
    .p-carousel-prev-button, .p-carousel-next-button{
        background: rgb(var(--site-primary-color-rgb));
        border-radius: 50%;
        color: #ffffff;
    }
}
</style>
